/**
 * Created by prog2 on 13/11/2018.
 */

export function onReady(store) {
    document.addEventListener("online", connect(store), false);
    document.addEventListener("offline", disconnect(store), false);

}
function connect(store) {
    store.commit('connection/toggle', true);
   // alert('Connected: ' + store.state.connection.connected);
}
function disconnect(store) {
    store.commit('connection/toggle', false);
    //alert('Connected: ' + store.state.connection.connected);
}




// WEBPACK FOOTER //
// ./src/events.js